import ArticleLink from '@/components/feature/ArticleLink';
import ScrollReveal from '@/components/base/ScrollReveal';
import SectionHeading from '@/components/base/SectionHeading';
import { tradingFlowSteps } from '@/mocks/forexTrading';

export default function TradingFlow() {
  return (
    <section className="border-y border-background-200 bg-background-100/60">
      <div className="mx-auto w-full max-w-7xl px-4 py-14 md:px-6 md:py-20 lg:px-10">
        <div className="flex flex-col gap-6 lg:flex-row lg:items-end lg:justify-between">
          <SectionHeading
            eyebrow="ลำดับการทำงาน"
            title="6 ขั้นตอน ตั้งแต่เปิดแผนจนปิดออเดอร์"
            subtitle="ทุกไม้ควรไหลตามลำดับนี้ ถ้าขั้นใดขั้นหนึ่งยังตอบไม่ได้ ให้หยุดแล้วกลับไปทำขั้นนั้นก่อน ดีกว่าฝืนกดออเดอร์แล้วมาแก้ทีหลัง"
          />
          <p className="flex w-fit shrink-0 items-center gap-2 rounded-full border border-background-300 bg-background-50 px-4 py-2 text-xs font-medium text-foreground-600">
            <i className="ri-arrow-down-line text-primary-600" />
            เรียงตามลำดับการทำงานจริง
          </p>
        </div>

        <div className="mt-10 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {tradingFlowSteps.map((step, index) => (
            <ScrollReveal key={step.no} delay={(index % 3) * 70} className="h-full">
              <article className="group flex h-full flex-col rounded-lg border border-background-200 bg-background-50 p-5 transition-colors duration-300 hover:border-primary-300">
                <div className="flex items-start justify-between gap-3">
                  <span
                    className={`flex h-10 w-10 items-center justify-center rounded-md ${
                      step.accent ? 'bg-accent-100 text-accent-700' : 'bg-primary-100 text-primary-700'
                    }`}
                  >
                    <i className={`${step.icon} text-lg`} />
                  </span>
                  <span
                    className={`font-num text-2xl font-semibold leading-none ${
                      step.accent ? 'text-accent-200' : 'text-background-300'
                    } transition-colors duration-300 group-hover:text-primary-300`}
                  >
                    {step.no}
                  </span>
                </div>

                <h3 className="mt-4 font-heading text-base font-semibold text-foreground-950 md:text-lg">
                  {step.title}
                </h3>
                <p className="mt-2 text-sm leading-relaxed text-foreground-600">{step.desc}</p>

                <ArticleLink
                  to={step.path}
                  className="mt-auto inline-flex w-fit items-center gap-1.5 pt-5 text-xs font-semibold text-primary-700 transition-colors hover:text-primary-900"
                >
                  {step.linkLabel}
                  <i className="ri-arrow-right-line text-sm" />
                </ArticleLink>
              </article>
            </ScrollReveal>
          ))}
        </div>
      </div>
    </section>
  );
}